import { render } from "./Favourites.vue?vue&type=template&id=36c1737a"
import script from "./Favourites.vue?vue&type=script&lang=js"
export * from "./Favourites.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vklosovych/Desktop/vue-exam/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__